module.exports = __webpack_public_path__ + "img/maps.222c7986.png";